import {
  extractBaseNameFromFilePath
} from '@smarttransit/common-client'

import {
  addAlert
} from '../../../../../utilities/helpers'

import {
  deleteGenericBusStopAudio,
  getGenericBusStopAudio,
  getGenericBusStopAudioSecureUrl,
  setGenericBusStopAudio
} from '../../../../../services/bus-stops-service'
import { attachSecureUrls, decorateAudioFile } from '../../audio-playback'

export default {
  name: 'bus-stops-generic-audio-modal',
  props: {
    openModal: Boolean,
    isEditable: Boolean,
    locales: {
      type: Array,
      required: true
    },
    onModalClose: Function
  },
  data () {
    return {
      genericBusStopAudioFiles: [],
      currentGenericBusStopAudio: null,
      modalGenericAudioUpdate: false,
      busStopAudioApiInProgress: false,
      genericBusStopAudioDocument: { documentsToUpload: [], uploadedDocuments: [] },
      genericTypes: [{ text: 'Next stop', value: 'next' }, { text: 'Arrived', value: 'arrived' }]
    }
  },
  mounted () {
    this.modalGenericAudioUpdate = this.$props.openModal
  },
  watch: {
    openModal (newVal) {
      this.modalGenericAudioUpdate = newVal

      if (newVal) {
        this.loadGenericAudioRecords()
      }
    },
    genericBusStopAudioDocument (documents) {
      if (this.currentGenericBusStopAudio) {
        this.currentGenericBusStopAudio.documentFile = null
      }

      if (documents?.documentsToUpload) {
        documents.documentsToUpload.forEach((newFile) => {
          if (!newFile.error) {
            this.currentGenericBusStopAudio = {
              ...this.currentGenericBusStopAudio,
              documentFile: newFile.file,
              documentFileUrl: URL.createObjectURL(newFile.file)
            }
          }
        })
      }
    }
  },
  computed: {
    filteredGenericTypes () {
      return this.genericBusStopAudioFiles && this.genericBusStopAudioFiles.length ? this.genericTypes.map((o) => {
        return { ...o, disabled: Boolean(this.genericBusStopAudioFiles.find((b) => (b.type === o.value && b.id !== this.currentGenericBusStopAudio.id))) }
      }) : this.genericTypes
    }
  },
  methods: {
    closeGenericBusStopModal () {
      this.modalGenericAudioUpdate = false

      if (this.$props.onModalClose) {
        this.$props.onModalClose()
      }
    },
    async loadGenericAudioRecords () {
      try {
        this.busStopAudioApiInProgress = true
        const genericBusStopAudioFiles = await getGenericBusStopAudio()
        const withUrls = await attachSecureUrls(genericBusStopAudioFiles, getGenericBusStopAudioSecureUrl)

        this.genericBusStopAudioFiles = withUrls.map(({ record, url }) => {
          return decorateAudioFile(record, {
            url,
            locales: this.locales,
            genericTypes: this.genericTypes
          })
        })
      } catch (err) {
        console.error('loadGenericAudioRecords error', err)
        addAlert({ message: err, type: 'error', isModal: true })
      } finally {
        this.busStopAudioApiInProgress = false
      }
    },
    async loadGenericBusStopAudioForm (busStopAudio) {
      this.currentGenericBusStopAudio = busStopAudio ? { ...busStopAudio } : {}

      if (this.currentGenericBusStopAudio.id) {
        this.genericBusStopAudioDocument = {
          ...this.genericBusStopAudioDocument,
          uploadedDocuments: [{
            filename: extractBaseNameFromFilePath(this.currentGenericBusStopAudio.documentSrc),
            type: this.currentGenericBusStopAudio.metadata.mimetype,
            size: this.currentGenericBusStopAudio.metadata.size
          }]
        }
      } else {
        this.genericBusStopAudioDocument = {
          ...this.genericBusStopAudioDocument,
          uploadedDocuments: []
        }
      }
    },
    async deleteGenericBusStopAudioForm (busStopAudio) {
      if (confirm(`Confirm deleting audio for ${busStopAudio.localeLabel}`)) {
        try {
          this.busStopAudioApiInProgress = true
          await deleteGenericBusStopAudio(busStopAudio.id)
          await this.loadGenericAudioRecords()
        } catch (error) {
          console.error('deleteGenericBusStopAudioForm error', error)
          addAlert({ message: error, type: 'error', isModal: true })
        } finally {
          this.busStopAudioApiInProgress = false
        }
      }
    },
    closeGenericBusStopAudioForm () {
      this.currentGenericBusStopAudio = null
    },
    clearGenericDocumentUpload () {
      this.currentGenericBusStopAudio.documentFile = null

      this.genericBusStopAudioDocument = {
        ...this.genericBusStopAudioDocument,
        documentsToUpload: []
      }
    },
    async saveGenericBusStopAudio () {
      try {
        if (!this.currentGenericBusStopAudio.locale) {
          alert('Please select a language/dialect')
          return
        }

        if (!this.currentGenericBusStopAudio.id && !this.currentGenericBusStopAudio.documentFile) {
          alert('Please upload an audio file')
          return
        }

        if (!this.currentGenericBusStopAudio.type) {
          alert('Please select a type')
          return
        }

        this.busStopAudioApiInProgress = true

        this.currentGenericBusStopAudio = await setGenericBusStopAudio({
          settingId: this.currentGenericBusStopAudio.id,
          type: this.currentGenericBusStopAudio.type,
          locale: this.currentGenericBusStopAudio.locale,
          documentFile: this.currentGenericBusStopAudio.documentFile
        })

        this.clearGenericDocumentUpload()
        this.closeGenericBusStopAudioForm()
        await this.loadGenericAudioRecords()
      } catch (error) {
        addAlert({ message: error, type: 'error', isModal: true })
      } finally {
        this.busStopAudioApiInProgress = false
      }
    }
  }
}
